import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import egrocareIcon from "../../../assets/Home/IntroSection/egrocare-card-icon.png";
import arrowEn from "../../../assets/Home/Egroscout/arrow-en.png";
import arrowAr from "../../../assets/Home/Egroscout/arrow-ar.png";
import logo from "../../../assets/Home/Egrocare/logo.png";
import video from "../../../assets/Home/Egrocare/video.mp4";
import { useTranslation, Trans } from "react-i18next";

const Egroscout = () => {
  const [t, i18n] = useTranslation(); //translation hook
  const arrow = i18n.language === "ar" ? arrowAr : arrowEn;

  return (
    <div id="egrocare" className={styles.container}>
      <section className={styles.leftSection}>
        <img src={logo} className={styles.logoIcon} alt="" />
        <video autoPlay muted loop className={styles.video}>
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className={styles.overlay}></div>
      </section>
      <section className={styles.rightSection}>
        <div className={styles.iconTitleWrapper}>
          <img src={egrocareIcon} alt="" className={styles.icon} />
          <h2 className={styles.title}>{t("Egro Care Pro")}</h2>
        </div>
        <h3 className={styles.description}>
          {t("All-In-One Farm Management System.")}
        </h3>
        <p className={styles.text}>
          {t("Welcome to Egro Care, the all-in-one farm management solution designed to transform the way businesses operate in the agriculture industry. Whether you're running a large-scale farm or agribusiness, Egro Care offers powerful analytics and reporting tools to streamline your operations and boost productivity.")}
        </p>
        <div className={styles.buttonsContainer}>
          <a
            href="https://play.google.com/store/apps/details?id=com.egrobots.pro.egrocare"
            target="_blank" // Opens the link in a new tab
            rel="noopener noreferrer" // Security best practice to prevent security risks
          >
            <button className={styles.downloadButton}>
              <span>{t("download the app")}</span>
            </button>
          </a>
          {/* <button className={styles.knowMoreButton}>
            <span>{t("know more")}</span>
            <img src={arrow} alt="arrow" className={styles.arrowIcon} />
          </button> */}
        </div>
      </section>
    </div>
  );
};

export default Egroscout;